/**
 * The three faces of the Statistics tab, in `?view=` on `/rankings`: the
 * power rankings table (the default), the analysis charts, and the league
 * statistics. Statistics was a tab of its own until 2026-10-23; it moved here
 * so the phone tab bar could fit five destinations without scrolling.
 */
export const RANKINGS_VIEWS = ['table', 'analysis', 'statistics'];
